import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { BaseCell } from "@similarweb/pro-logic-components";
import { DropdownItem, IconButton } from "@similarweb/ui-components";

export const StyledBaseCell = styled(BaseCell)`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const StyledCraftEmailIconButton = styled(IconButton)`
    ${SWReactIcons} {
        svg path {
            &:nth-child(1) {
                fill: url("#paint0_linear_518_14302") !important;
            }

            &:nth-child(2) {
                fill: url("#paint1_linear_518_14302") !important;
            }
        }
    }
`;

export const StyledDDItemWrapper = styled(DropdownItem)`
    display: block;
    padding: 8px;
    height: auto;

    &:hover {
        background-color: transparent !important;
    }
`;
